import { useEffect, useRef, useState } from 'react';

const EMPTY_FORM = {
    idAviso: 0,
    avisoContenido: '',
    idEmpresa: '',
    fechaCaducidad: '',
    activo: true,
};

export default function AvisosPrivacidadModal({
    open,
    mode = 'new',
    data = null,
    onClose,
    onSubmit,
    inline = false,
    empresaOptions = [],
}) {
    const [form, setForm] = useState(EMPTY_FORM);
    const [errors, setErrors] = useState({ avisoContenido: '' });
    const contentInputRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        if (mode === 'edit' && data) {
            setForm({
                idAviso: data.idAviso ?? 0,
                avisoContenido: data.avisoContenido ?? '',
                idEmpresa: data.idEmpresa != null ? String(data.idEmpresa) : '',
                fechaCaducidad: data.fechaCaducidad ? new Date(data.fechaCaducidad).toISOString().split('T')[0] : '',
                activo: data.activo ?? true,
            });
        } else {
            setForm({ ...EMPTY_FORM });
            setErrors({ avisoContenido: '' });
        }
    }, [open, mode, data]);

    const validateField = (field, value) => {
        let error = '';
        if (field === 'avisoContenido' && !value?.trim()) {
            error = 'El contenido del aviso es requerido.';
        }
        setErrors((prev) => ({ ...prev, [field]: error }));
        return !error;
    };

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
        if (field === 'avisoContenido') validateField('avisoContenido', value);
    };

    const handleSubmit = () => {
        if (!validateField('avisoContenido', form.avisoContenido)) return;
        const payload = {
            ...form,
            idEmpresa: form.idEmpresa === '' ? null : Number(form.idEmpresa),
        };
        onSubmit?.(payload, mode);
    };

    if (!open) return null;

    const Header = (
        <div className="roles-topbar" style={{ paddingRight: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flex: '0 0 auto' }}>
            <h3 className="roles-title">
                {mode === 'new' ? 'Nuevo Aviso de Privacidad' : 'Editar Aviso de Privacidad'}
            </h3>
            <button className="roles-btn" onClick={onClose}>✕</button>
        </div>
    );

    const Body = (
        <div style={{ padding: '0 16px 16px 16px', display: 'grid', gridTemplateColumns: '1fr', gap: '1rem', overflowY: 'auto', flex: '1 1 auto' }}>
            <div>
                <label className="roles-title" style={{ fontSize: '.9rem' }}>Contenido del Aviso *</label>
                <textarea
                    className={`infoField ${errors.avisoContenido ? 'infoField--error' : ''}`}
                    ref={contentInputRef}
                    value={form.avisoContenido}
                    onChange={(e) => handleChange('avisoContenido', e.target.value)}
                    style={{ minHeight: '120px', width: '100%', marginTop: '0.5rem' }}
                />
                {errors.avisoContenido && (
                    <small style={{ color: '#b91c1c' }}>{errors.avisoContenido}</small>
                )}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div>
                    <label className="roles-title" style={{ fontSize: '.9rem' }}>Empresa</label>
                    <select
                        className="infoField"
                        value={form.idEmpresa}
                        onChange={(e) => handleChange('idEmpresa', e.target.value)}
                        style={{ width: '100%', marginTop: '0.5rem' }}
                    >
                        <option value="">Selecciona una empresa...</option>
                        {empresaOptions.map((opt) => (
                            <option key={opt.idEmpresa} value={opt.idEmpresa}>{opt.nombre}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="roles-title" style={{ fontSize: '.9rem' }}>Fecha de Caducidad</label>
                    <input
                        type="date"
                        className="infoField"
                        value={form.fechaCaducidad}
                        onChange={(e) => handleChange('fechaCaducidad', e.target.value)}
                        style={{ width: '100%', marginTop: '0.5rem' }}
                    />
                </div>
            </div>
        </div>
    );

    const Footer = (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '.6rem', padding: '16px', flex: '0 0 auto' }}>
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button className="btn-action" onClick={handleSubmit}>
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    if (inline) {
        return (
            <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {Header}
                {Body}
                {Footer}
            </div>
        );
    }

    return (
        <div className="roles-confirm-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="roles-confirm-card" style={{ width: 'min(700px, 95vw)', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
                {Header}
                {Body}
                {Footer}
            </div>
        </div>
    );
}
